import ABCyaPhaser from "@abcya/abcya_phaser";
import Phaser from "phaser";
import gameData from "../gameData";
import SoundController from "../SoundController";
import SoundAssetKeys from "../SoundAssetKeys";
import UIAssetKeys from "../UIAssetKeys";
import Level from "./Level";
import FontKeys from "../FontKeys";
import ABCyaLib from "@abcya/abcya_lib";

const Constants = {
  INITIAL_DELAY: 250,
  LETTER_SOUND_INITIAL_DELAY: 0.25,
  LETTER_SOUND_LETTER_DELAY: 0.15,
  LETTER_WIDTH: 175,
  LETTER_HEIGHT: 175,
  LETTER_SPACE_Y: 125,
  LETTER_DELAY: 150,
  LETTER_TWEEN: 500,
  FRAME_DELAY: 1250,
  START_TWEEN: 400,
  START_DELAY: 250,
};

export default class Title extends Phaser.Scene {
  static get KEY() {
    return "Title";
  }

  preload() {
    // preload your assets here, if needed
  }

  create() {
    SoundController.initScene(this);

    this.bg = ABCyaPhaser.Images.addImage(
      0,
      0,
      UIAssetKeys._GameBackground,
      this
    );
    this.bg.setOrigin(0, 0);

    // Letter tweens
    const letterIds = [
      ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.title.top_line").split(''),
      ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.title.bottom_line").split(''),
    ];
    this.titleContainer = this.add.container(
      this.sys.game.canvas.width * 0.5,
      this.sys.game.canvas.height * 0.2
    );
    let index = 0;
    let letterBgKey = UIAssetKeys._LogoTopLetters;
    let letterTxtColor = 0x1df4ff;
    // used to offset the lines a bit, used because Spanish has the same number of characters in each line
    let lineOffset = ABCyaLib.Environment.instance.locale === 'es-US' ? -0.25 : 0;
    for (var i = 0; i < letterIds.length; i++) {
      const wordLetters = letterIds[i];
      const wordWidth = wordLetters.length * Constants.LETTER_WIDTH;
      for (var n = 0; n < wordLetters.length; n++) {
        const letterX =
          Constants.LETTER_WIDTH * lineOffset +
          wordWidth * -0.5 +
          Constants.LETTER_WIDTH * 0.5 +
          n * Constants.LETTER_WIDTH;
        const letterY = -this.titleContainer.y + -Constants.LETTER_HEIGHT;
        const finalY = i * Constants.LETTER_SPACE_Y;
        const letter = this.add.container(letterX, letterY);
        this.titleContainer.add(letter);
        const letterBg = ABCyaPhaser.Images.addImage(0,0,letterBgKey, letter);
        const letterTxt = ABCyaPhaser.Text.addText(0,0, 126, letterTxtColor, FontKeys._nulshockbold, wordLetters[n], letter, true);

        ABCyaPhaser.Tweens.addTween(
          letter,
          Constants.LETTER_TWEEN,
          { delay: index * Constants.LETTER_DELAY, y: finalY },
          Phaser.Math.Easing.Bounce.Out
        );
        ABCyaPhaser.Audio.playOneShot(
          SoundAssetKeys._Letter_Tweens,
          this,
          1,
          false,
          Constants.LETTER_SOUND_INITIAL_DELAY +
            index * Constants.LETTER_SOUND_LETTER_DELAY
        );
        index++;
      }
      letterBgKey = UIAssetKeys._LogoBottomLetters;
      letterTxtColor = 0xfffeeb;
      lineOffset = -lineOffset;
    }

    // Credit line tween
    var creditLine = ABCyaPhaser.Text.addText(this.scale.width*0.5, this.scale.height*0.9, 24, 0x10b6dd, FontKeys._nokioregular, ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.credits"), this, true);
    creditLine.alpha = 0;
    ABCyaPhaser.Tweens.addTween(
      creditLine,
      Constants.START_TWEEN,
      { delay: Constants.FRAME_DELAY, alpha: 1 },
      Phaser.Math.Easing.Cubic.In
    );

    // Start button tweens
    const leftFrame = ABCyaPhaser.Images.addImage(
      0,
      450,
      UIAssetKeys._StartBtnFrameLeft,
      this
    );
    leftFrame.x = -leftFrame.displayWidth;
    leftFrame.setOrigin(0, 0);

    const rightFrame = ABCyaPhaser.Images.addImage(
      this.sys.game.canvas.width + leftFrame.displayWidth,
      leftFrame.y + 112,
      UIAssetKeys._StartBtnFrameLeft,
      this
    );
    rightFrame.setOrigin(0, 0);
    rightFrame.setScale(-1);

    const finalX = -180;

    ABCyaPhaser.Tweens.addTween(
      leftFrame,
      Constants.START_TWEEN,
      { delay: Constants.FRAME_DELAY, x: finalX },
      Phaser.Math.Easing.Cubic.In
    );
    ABCyaPhaser.Tweens.addTween(
      rightFrame,
      Constants.START_TWEEN,
      { delay: Constants.FRAME_DELAY, x: this.sys.game.canvas.width - finalX },
      Phaser.Math.Easing.Cubic.In
    );

    // Start button tween
    const startButton = ABCyaPhaser.Images.addImage(
      this.sys.game.canvas.width * 0.5,
      505,
      UIAssetKeys._StartBtn,
      this
    );
    startButton.setInteractive({ cursor: "pointer" });
    startButton.alpha = 0;

    ABCyaPhaser.Tweens.addTween(
      startButton,
      Constants.START_TWEEN,
      {
        delay: Constants.FRAME_DELAY,
        alpha: 1,
      },
      Phaser.Math.Easing.Cubic.In,
      () => {
        startButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (e) => {
          ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Click, this);
          startButton.removeAllListeners();
          this.scene.start(Level.KEY);
        });
      }
    );

    this.sound.mute = gameData.isMuted;
  }
}
